/*
 * School Management System API
 * APIs for managing branches, employees, students, receipts, etc.
 *
 * OpenAPI spec version: 1.0.0
 * Contact: tejabhargavpodila@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.54
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The SendEmailRequest model module.
 * @module model/SendEmailRequest
 * @version 1.0.0
 */
export default class SendEmailRequest {
  /**
   * Constructs a new <code>SendEmailRequest</code>.
   * @alias module:model/SendEmailRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SendEmailRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SendEmailRequest} obj Optional instance to populate.
   * @return {module:model/SendEmailRequest} The populated <code>SendEmailRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SendEmailRequest();
      if (data.hasOwnProperty('subject'))
        obj.subject = ApiClient.convertToType(data['subject'], 'String');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} subject
 */
SendEmailRequest.prototype.subject = undefined;

/**
 * @member {String} message
 */
SendEmailRequest.prototype.message = undefined;

